import React, {useEffect, useState} from 'react';
import styles from './LandscapeWarning.module.scss';
import {isMobileDevice} from "utils/Device";
import FlipPhone from "components/icons/flipPhone/FlipPhone";
import {useSelector} from "react-redux";

const LandscapeWarning = (props) => {

    const mobile = isMobileDevice();
    const [warning, setWarning] = useState(false);
    const windowData = useSelector(state => state.window);


    useEffect(()=>{

        setWarning( mobile && windowData.width > windowData.height);

    }, [setWarning, windowData, mobile])

    return warning ? (
       <div className={styles.landscapeWarning}>

           <div>For the best experience,<br/>flip your phone vertically.</div>
           <div className={`${styles.flip} ${styles.bl}`}><FlipPhone/></div>
           <div className={`${styles.flip} ${styles.tr}`}><FlipPhone/></div>
       </div>
    ) : '';
};

export default LandscapeWarning
